import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import ModalPortal, { MODAL_Z } from './ModalPortal';

/**
 * Controlled confirmation dialog. DeleteConfirmatationModal renders its own
 * trigger button, which does not suit callers that already have one (a row
 * action, an icon button) and need to drive the open state themselves.
 */
export default function ConfirmDialog({
  isOpen,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  destructive = true,
  isProcessing = false,
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  return (
    <ModalPortal isOpen={isOpen} onClose={isProcessing ? undefined : onCancel}>
      <div className={`fixed inset-0 ${MODAL_Z} flex items-center justify-center p-4`}>
        <div
          className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm"
          onClick={isProcessing ? undefined : onCancel}
          aria-hidden="true"
        />
        <div role="dialog" aria-modal="true" className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
          <div className="flex items-start gap-3">
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${
                destructive ? 'bg-rose-100 text-rose-600' : 'bg-primary-100 text-primary-600'
              }`}
            >
              <FaExclamationTriangle />
            </span>
            <div className="min-w-0">
              <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
              {message && <p className="mt-1 text-sm text-slate-600">{message}</p>}
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-2">
            <button
              type="button"
              onClick={onCancel}
              disabled={isProcessing}
              className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isProcessing}
              className={`rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:opacity-60 ${
                destructive ? 'bg-rose-600 hover:bg-rose-700' : 'bg-primary-500 hover:bg-primary-600'
              }`}
            >
              {isProcessing ? 'Working…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}
